import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: 'Home', path: '/' },
  { label: 'About Us', path: '/about' },
  { label: 'Portfolio', path: '/portfolio' },
  { label: 'Sectors', path: '/sectors' },
  { label: 'Investor Relations', path: '/investor-relations' },
  { label: 'Contact', path: '/contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-white/95 backdrop-blur-md border-b border-foreground-100/40'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-6 md:px-12 flex items-center justify-between h-20">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3 cursor-pointer shrink-0">
          <img
            src="https://public.readdy.ai/ai/img_res/19af8b46-b82f-4082-a445-0c39f1d79e15.png"
            alt="Swiss Microfinance Holding SA"
            className={`h-12 w-auto object-contain transition-all duration-500 ${scrolled ? '' : 'brightness-0 invert'}`}
          />
        </Link>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-6">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-xs uppercase tracking-[2px] font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                location.pathname === link.path
                  ? 'text-primary-600'
                  : scrolled
                    ? 'text-foreground-600 hover:text-primary-500'
                    : 'text-foreground-700 hover:text-primary-500'
              }`}
            >
              {link.label}
            </Link>
          ))}
          <a
            href="/contact"
            className="ml-2 bg-primary-500 hover:bg-primary-600 text-white text-xs uppercase tracking-[2px] font-semibold px-5 py-2.5 rounded-md transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Investor Inquiry
          </a>
        </div>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden flex flex-col gap-1.5 cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span className={`block w-6 h-0.5 transition-all duration-300 ${scrolled ? 'bg-foreground-900' : 'bg-foreground-950'} ${menuOpen ? 'rotate-45 translate-y-2' : ''}`} />
          <span className={`block w-6 h-0.5 transition-all duration-300 ${scrolled ? 'bg-foreground-900' : 'bg-foreground-950'} ${menuOpen ? 'opacity-0' : ''}`} />
          <span className={`block w-6 h-0.5 transition-all duration-300 ${scrolled ? 'bg-foreground-900' : 'bg-foreground-950'} ${menuOpen ? '-rotate-45 -translate-y-2' : ''}`} />
        </button>
      </div>

      {/* Mobile Menu Overlay */}
      {menuOpen && (
        <div
          className="fixed inset-0 bg-black/30 z-40 md:hidden"
          onClick={() => setMenuOpen(false)}
        />
      )}

      {/* Mobile Menu Panel */}
      <div
        className={`md:hidden fixed top-20 left-0 right-0 z-50 bg-white/98 backdrop-blur-md px-6 pb-6 flex flex-col gap-1 transition-all duration-300 ${
          menuOpen ? 'opacity-100 translate-y-0 pointer-events-auto' : 'opacity-0 -translate-y-4 pointer-events-none'
        }`}
      >
        {navLinks.map((link) => (
          <Link
            key={link.path}
            to={link.path}
            onClick={() => setMenuOpen(false)}
            className={`text-sm uppercase tracking-[2px] font-medium py-4 border-b border-foreground-50/20 cursor-pointer ${
              location.pathname === link.path ? 'text-primary-600' : 'text-foreground-700'
            }`}
          >
            {link.label}
          </Link>
        ))}
        <a
          href="/contact"
          className="mt-3 bg-primary-500 text-white text-sm uppercase tracking-[2px] font-semibold py-3.5 rounded-md text-center cursor-pointer"
        >
          Investor Inquiry
        </a>
      </div>
    </nav>
  );
}